import DetailCardBody from '@/common/components/DetailCard/DetailCardBody.tsx';
import DetailCardItems from '@/common/components/DetailCard/DetailCardItems.tsx';
import MainDetailCard from '@/common/components/DetailCard/MainDetailCard.tsx';
import FileHeader from '@/common/components/DetailCard/headers/fileHeader/FileHeader.tsx';
import useInfinityScroll from '@/common/hooks/useInfinityScroll.ts';
import FileListDetailCardActions from '@/modules/FileList/components/fileDetailCardActions/FileListDetailCardActions.tsx';
import { MyFilesListReturnType } from '@/modules/FileList/components/fileList/FileList.type.ts';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const FileList = ({ myFilesData, fetchNextPage }: MyFilesListReturnType) => {
  const { observerRefCallback } = useInfinityScroll(fetchNextPage);

  return (
    <>
      {myFilesData?.pages.map((pageData, pageIndex) =>
        pageData.results.map((file, index) => (
          <Box key={file.id} ref={observerRefCallback}>
            <MainDetailCard
              className={css({
                mb:
                  index === pageData.results?.length - 1 &&
                  myFilesData?.pages.length === pageIndex + 1
                    ? '100px'
                    : '20px',
              })}
            >
              <FileHeader
                fileDetail={{ id: file.id }}
                index={pageIndex * pageData.page_size + index + 1}
                fileType={file.file_type.const}
              />
              <DetailCardBody>
                <DetailCardItems items={file.detailCardItems ?? []} />
              </DetailCardBody>
              <FileListDetailCardActions action={file.action} id={file.id} />
            </MainDetailCard>
          </Box>
        )),
      )}
    </>
  );
};
export default FileList;
